import { useState } from "react";

const DYNAMIC_MODULE_ACTIONS = ["add", "get", "update", "delete"];

// Child permissions of a checkpoint (checkpoint-<id>-<perm>), in display order.
export const CHECKPOINT_CHILD_PERMS = ["manualEntry", "viewSubmit", "viewDetail", "viewListing"];

// Warehouse permissions: enabled keys of the vms permission set (applied as plant-<plantId>-<key>).
export function getWarehousePermissions(permissionSetPerms = {}) {
	return Object.keys(permissionSetPerms.vms || {}).filter((perm) => permissionSetPerms.vms[perm]?.value);
}

/**
 * General (non-plant) permissions as [{ module, perm }]: non-vms permission sets + dynamic module permissions (vms).
 */
export function getGeneralPermissions(permissionSetPerms = {}, dynamicModules = [], { allowManagePlant = false } = {}) {
	const generalPerms = [];
	for (const module in permissionSetPerms) {
		// vms permissions are per plant
		if (module === "vms") continue;
		for (const perm in permissionSetPerms[module]) {
			if (!permissionSetPerms[module][perm]?.value) continue;
			if (!allowManagePlant && ["addPlant", "deletePlant"].includes(perm)) continue;
			generalPerms.push({ module, perm });
		}
	}
	dynamicModules.forEach((dynamicModule) => {
		const moduleName = dynamicModule.moduleName.replaceAll(" ", "");
		DYNAMIC_MODULE_ACTIONS.forEach((action) => generalPerms.push({ module: "vms", perm: `module-${action}${moduleName}` }));
	});
	return generalPerms;
}

export const AccordionWrapperVanilla = ({ title, children, isOpenAcc = false }) => {
	const [expanded, setExpanded] = useState(isOpenAcc);

	//todo animate the opening and closing
	return (
		<div className={`accordion ${expanded ? "open" : ""}`}>
			<div className="accordion-header" onClick={() => setExpanded(!expanded)}>
				<span>{title}</span>
				<span className="arrow">&#9662;</span>
			</div>
			<div className="accordion-body">{expanded ? children : null}</div>
		</div>
	);
};
